import React, { useState, useEffect, useRef } from 'react'
// import { useIntl } from 'react-intl'
import Popover from 'components/popover'
import { Simple } from 'components/button'
import { ColumnEdit } from 'components/feather'
import ColumnConfiguratorContent from './content'

const ColumnConfigurator = ({ editingColumns, setEditingColumns, salt, ...props }) => {
    // const { formatMessage } = useIntl()

    const [acting, setActing] = useState(false)

    useEffect(() => {
        if(editingColumns) {
            setActing(true)
        }

        if(!acting) {
            setEditingColumns?.(false)
        }
    }, [acting, editingColumns])

    const control = useRef()

    return (
        <Popover
            content={(
                <ColumnConfiguratorContent
                    {...props}
                    salt={salt} />
            )}
            interactive={true}
            placement="bottom-end"
            trigger="click"
            className="column-configurator"
            // tooltip={formatMessage({
            //     id: 'edit_columns_label',
            //     defaultMessage: 'Edit columns'
            // })}
            >
            <Simple
                icon={ColumnEdit}
                onClick={() => setActing(!acting)}
                ref={control} />
        </Popover>
    )
}

export default ColumnConfigurator
